import { inject, Injectable, signal } from "@angular/core";
import { YearAcademyService } from "../../../../../../core/services/year-academy/year-academy.service";
import { YearAcademy } from "../../../../../../core/services/year-academy/types";

@Injectable({
    providedIn: 'root'
})
export class NavbarStore {
    private readonly yearAcademyService = inject(YearAcademyService);
    readonly selectedYearAcademy = signal<YearAcademy | undefined>(undefined);
    readonly isLoading = signal(false);
    readonly yearsAcademy = signal<YearAcademy[]>([]);
    readonly loadingYearsAcademy = signal(false);

    constructor() {
        localStorage.removeItem('selected_site');
    }

    getYearsAcademy() {
        this.isLoading.set(true);
        return this.yearAcademyService.getYearsAcademy().subscribe({
            next: (response) => {

                this.selectedYearAcademy.set(response.data.find(year => year.isActual));
                this.yearsAcademy.set(response.data);
                this.isLoading.set(false);
            },
            error: () => {
                this.isLoading.set(false);
            }
        });
    }
}
